import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import React from "react";

const ItemWithLocationRuleModel = (): ColumnMain => {
    const columns: Array<Column> = new Array();
    columns.push({key: 'location.name', dataIndex: ['location', 'name'], width: 250, sorter: true, title: <Trans>Location name of the relevant commodity</Trans>});
    columns.push({key: 'itemNo', width: 200, sorter: true, title: <Trans>MSC Part Number</Trans>, direction: 'asc'});
    columns.push({key: 'quantity', width: 200, sorter: true, title: <Trans>Relevant quantity from declared location</Trans>});
    columns.push({key: 'validFrom', width: 170, dateFilter: true, sorter: true, title: <Trans>Valid From</Trans>});
    columns.push({key: 'validTo', width: 170, dateFilter: true, sorter: true, title: <Trans>Valid To</Trans>});
    return {
        columns: columns,
        url: '/resource/items-with-location-rules'
    };
};
export default ItemWithLocationRuleModel();
